import React from 'react';
import { FiExternalLink } from 'react-icons/fi';

const BrokerConnectingModal = ({ isOpen, brokerName }) => {
  if (!isOpen) return null;

  const getBrokerDisplayName = (broker) => {
    const displayNames = {
      'tradier': 'Tradier',
      'tastytrade': 'TastyTrade',
      'schwab': 'Charles Schwab',
      'interactiveBroker': 'Interactive Brokers',
      'interactive_brokers': 'Interactive Brokers'
    };
    return displayNames[broker] || broker.charAt(0).toUpperCase() + broker.slice(1).replace('_', ' ');
  };

  return (
    <div className="fixed inset-0 bg-black/75 backdrop-blur-sm flex items-center justify-center z-[9999]">
      <div className="bg-gray-900 rounded-xl p-8 max-w-md w-full mx-4 border border-purple-500/30 shadow-2xl">
        <div className="text-center">
          {/* Animated Logo/Icon */}
          <div className="mb-6 relative">
            <div className="w-20 h-20 mx-auto relative">
              <div className="absolute inset-0 bg-purple-500/20 rounded-full animate-ping"></div>
              <div className="absolute inset-0 bg-purple-500/30 rounded-full animate-ping animation-delay-200"></div>
              <div className="relative bg-gradient-to-br from-purple-500 to-purple-700 rounded-full w-20 h-20 flex items-center justify-center">
                <FiExternalLink className="w-10 h-10 text-white" />
              </div>
            </div>
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold text-white mb-3">
            Connecting to {getBrokerDisplayName(brokerName)}
          </h2>

          {/* Description */}
          <p className="text-gray-300 mb-6">
            Please wait while we redirect you to {getBrokerDisplayName(brokerName)}'s secure authentication page...
          </p>

          {/* Progress Steps */}
          <div className="space-y-3 text-left bg-gray-800/50 rounded-lg p-4">
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <span className="text-gray-300 text-sm">Generating secure OAuth token</span>
            </div>
            
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <span className="text-gray-300 text-sm">Validating broker connection</span>
            </div>
            
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 rounded-full bg-purple-500 flex items-center justify-center">
                <div className="w-3 h-3 bg-white rounded-full animate-pulse"></div>
              </div>
              <span className="text-gray-300 text-sm">Redirecting to broker login...</span>
            </div>
          </div>

          {/* Loading Animation */}
          <div className="mt-6">
            <div className="w-full bg-gray-700 rounded-full h-2 overflow-hidden">
              <div className="bg-gradient-to-r from-purple-500 to-purple-600 h-full rounded-full animate-progress"></div>
            </div>
          </div>

          {/* Info Text */}
          <p className="text-gray-500 text-xs mt-4">
            You will be redirected to a secure login page. After authentication, you'll be returned to the dashboard.
          </p>
        </div>
      </div>

      <style jsx>{`
        @keyframes progress {
          0% {
            width: 0%;
          }
          100% {
            width: 100%;
          }
        }
        
        .animate-progress {
          animation: progress 3s ease-in-out infinite;
        }
        
        .animation-delay-200 {
          animation-delay: 0.2s;
        }
      `}</style>
    </div>
  );
};

export default BrokerConnectingModal;